import { getDeviationPath, getDeviationResourceType } from '../../DeviationViews/_helpers';
import matchRoutes from '../../redux/routing/matchRoutes';
import { getDeviationEntityId, deviationSchema } from '../../redux/normalizr/schemas/deviation';
import { FEEDBACK_PAGE_DUPERBROWSE_ITEMID } from './constants';
import isString from 'lodash/isString';
import isNumber from 'lodash/isNumber';
import { BiData } from '@wix/da-bi/pkg/events';
export function isDeviation(item) {
    return item.hasOwnProperty('deviationId');
}
export function isDeviationStream(stream) {
    return stream.items.every(isDeviation);
}
export function isNormalizedStream(stream) {
    return stream.items.every((item)=>isNumber(item) || isString(item)) && !!stream.itemSchema;
}
export function getStreamItemId(item) {
    if (item === undefined) {
        return;
    }
    if (isDeviation(item)) {
        return item.deviationId;
    }
    if (isNumber(item) || isString(item)) {
        return item;
    }
}
export function getNormalizedStreamItemId(item) {
    if (isNumber(item) || isString(item)) {
        return item;
    }
    if (isDeviation(item)) {
        return getDeviationEntityId(item);
    }
}
export function getStreamItemUrl(item) {
    if (isDeviation(item)) {
        return getDeviationPath(item);
    }
    if (item === FEEDBACK_PAGE_DUPERBROWSE_ITEMID) {
        return '/notifications';
    }
}
export function getHtmlIdForStreamItem(stream, itemId) {
    return `duper-${stream.streamId}-${itemId}`;
}
export function isDuperbrowseLocation(location, ignoreState = false) {
    // if there is known state, it's ours for sure
    if (!ignoreState && location.state && (location.state.hasOwnProperty('duperbrowseState') || location.state.hasOwnProperty('duperbrowseRoot'))) {
        return true;
    }
    const routeMatches = matchRoutes({
        key: 'devpagelike',
        path: [
            '/:username/art/:deviationIdLike',
            '/:username/journal/:deviationIdLike',
            '/:username/status-update/:deviationIdLike',
            '/:username/poll/:deviationIdLike',
            '/:username/commission/:deviationIdLike',
            '/:username/tier/:deviationIdLike'
        ],
        exact: true
    }, location.pathname, false);
    return routeMatches.length > 0;
}
export function getDuperbrowseItemSchema(schema) {
    switch(schema){
        case 'deviation':
            return deviationSchema;
        default:
    }
}
export function getBasicBiDataForDuperItem(item) {
    if (isDeviation(item)) {
        return {
            itemid: item.deviationId,
            typeid: getDeviationResourceType(item)
        };
    }
}
export function getBiEventData(currentItem, direction, nextItem) {
    var _getBasicBiDataForDuperItem;
    const { itemid, typeid } = (_getBasicBiDataForDuperItem = getBasicBiDataForDuperItem(currentItem)) !== null && _getBasicBiDataForDuperItem !== void 0 ? _getBasicBiDataForDuperItem : {};
    var _ref;
    const { itemid: next_itemid } = (_ref = nextItem && getBasicBiDataForDuperItem(nextItem)) !== null && _ref !== void 0 ? _ref : {};
    return BiData({
        evid: 300,
        direction: direction === 'prev' ? 'previous' : direction,
        itemid: itemid !== null && itemid !== void 0 ? itemid : 0,
        typeid: typeid !== null && typeid !== void 0 ? typeid : 0,
        next_itemid: next_itemid
    });
}
